// Stall Participant routes
export const stallParticipantProfile = 'stall-participant/profile'
export const stallParticipantProfileList = stallParticipantProfile + '/list'
export const stallParticipantProfileStore = stallParticipantProfile + '/store'
export const stallParticipantProfileUpdate = stallParticipantProfile + '/update'
export const stallParticipantProfileShow = stallParticipantProfile + '/profile-info'

// Apply FOr Stall routes
export const stallProfileShow = 'stall-participant/apply-stall/profile-info'
export const applyStallStore = 'stall-participant/apply-stall/store'
export const pendingapplyStallStore = 'stall-participant/apply-stall/pending-store'
export const applyStallList = 'stall-participant/apply-stall/list'
export const applyStallShow = 'stall-participant/apply-stall/show'
export const applyStallUpdate = 'stall-participant/apply-stall/update'
export const stallInfoData = 'stall-participant/apply-stall/stall-info'
export const moneyReceiptApi = 'stall-participant/apply-stall/payment-receipt'

// Stall Participant E Certificate routes
export const stallParticipantCertificate = 'stall-participant/certificate'
export const stallParticipantCertificateData = stallParticipantCertificate + '/data'

// Stall Participant Every Summary Report
export const stallPanelEventSummaryReport = 'stall-participant/reports/event-summary'
export const reportHeadingList = '/configuration/report-heading/detail'
export const stallParticipantCertificateDataList = stallParticipantCertificate + '/datalist'
export const reportHeadingListNew = 'configuration/report-heading/listnew'

// Dashboard
export const dashboardData = 'stall-participant/dashboard/data'

// Payment Api Routes.....
export const getStallList = 'stall-participant/payment/stall-list'
